import { useState } from "react";

import { Button, DropdownMenu } from "@eisox/design-system";
import { ChevronDownIcon, HistoryIcon } from "@eisox/icons";

import { DefectHistoryDialog } from "~/features/module-defect";
import { m } from "~/paraglide/messages";

import { useAirHandlerUnitContext } from "../providers/air-handler-unit.provider";
import { DetailedHistoryDialog } from "./detailed-history-dialog";

const NAME = "DisplayDropdownMenu";

enum DisplayDialog {
  DETAILED_HISTORY,
  DEFECT_HISTORY,
}

interface DisplayDropdownMenuProps {
  buildingId: string;
  airHandlerUnitId: string;
}

export const DisplayDropdownMenu: React.FC<DisplayDropdownMenuProps> = ({ buildingId, airHandlerUnitId }) => {
  const { airHandlerUnits } = useAirHandlerUnitContext(NAME);

  const [openDialog, setOpenDialog] = useState<DisplayDialog>();

  const handleCloseDialog = () => setOpenDialog(undefined);

  return (
    <>
      <DropdownMenu.Root modal={false}>
        <DropdownMenu.Trigger asChild>
          <Button>
            {m.display()} <ChevronDownIcon />
          </Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align="end" sideOffset={10}>
          <DropdownMenu.Item onSelect={() => setOpenDialog(DisplayDialog.DETAILED_HISTORY)}>
            <HistoryIcon /> {m.detailed_history()}
          </DropdownMenu.Item>
          <DropdownMenu.Item onSelect={() => setOpenDialog(DisplayDialog.DEFECT_HISTORY)}>
            <HistoryIcon /> {m.default_history()}
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Root>

      {openDialog === DisplayDialog.DETAILED_HISTORY && (
        <DetailedHistoryDialog
          open
          onOpenChange={handleCloseDialog}
          buildingId={buildingId}
          airHandlerUnits={airHandlerUnits}
        />
      )}
      {openDialog === DisplayDialog.DEFECT_HISTORY && (
        <DefectHistoryDialog
          open
          onOpenChange={handleCloseDialog}
          buildingId={buildingId}
          scope="airHandlerUnit"
          entityId={airHandlerUnitId}
        />
      )}
    </>
  );
};

DisplayDropdownMenu.displayName = "DisplayDropdownMenu";
